/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementJustification } from './SupplementJustification';
import {
    SupplementJustificationFromJSON,
    SupplementJustificationFromJSONTyped,
    SupplementJustificationToJSON,
    SupplementJustificationToJSONTyped,
} from './SupplementJustification';

/**
 * Response containing updated justifications
 * @export
 * @interface UpdateSupplementJustificationsResponse
 */
export interface UpdateSupplementJustificationsResponse {
    /**
     * Array of updated supplement justifications
     * @type {Array<SupplementJustification>}
     * @memberof UpdateSupplementJustificationsResponse
     */
    updatedJustifications: Array<SupplementJustification>;
}

/**
 * Check if a given object implements the UpdateSupplementJustificationsResponse interface.
 */
export function instanceOfUpdateSupplementJustificationsResponse(value: object): value is UpdateSupplementJustificationsResponse {
    if (!('updatedJustifications' in value) || value['updatedJustifications'] === undefined) return false;
    return true;
}

export function UpdateSupplementJustificationsResponseFromJSON(json: any): UpdateSupplementJustificationsResponse {
    return UpdateSupplementJustificationsResponseFromJSONTyped(json, false);
}

export function UpdateSupplementJustificationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementJustificationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedJustifications': ((json['updatedJustifications'] as Array<any>).map(SupplementJustificationFromJSON)),
    };
}

export function UpdateSupplementJustificationsResponseToJSON(json: any): UpdateSupplementJustificationsResponse {
    return UpdateSupplementJustificationsResponseToJSONTyped(json, false);
}

export function UpdateSupplementJustificationsResponseToJSONTyped(value?: UpdateSupplementJustificationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedJustifications': ((value['updatedJustifications'] as Array<any>).map(SupplementJustificationToJSON)),
    };
}

